import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import DescarteInutilizavel from "model/patrimonio/DescarteInutilizavel";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { useEffect, useState } from "react";

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    style?: React.CSSProperties | undefined;
    estoqueLote: EstoqueLote;
    isRecup: boolean;
    onConfirm: (descarteInutilizavel: DescarteInutilizavel) => void;
}

export default function DescarteInutilizavelModal(props: Props) {

    const [descarteInutilizavel, setDescarteInutilizavel] = useState<DescarteInutilizavel>(new DescarteInutilizavel());

    const { msgAlerta } = useToastContext();

    useEffect(() => {
        if (props.visible) {
            setDescarteInutilizavel({
                ...descarteInutilizavel,
                estoqueLote: props.estoqueLote
            });
        }
    }, [props.visible, props.estoqueLote]); 

    useEffect(() => {
        if (!props.visible) {
            setDescarteInutilizavel({estoqueLote: new EstoqueLote(), quantidadeDescartavel: 0.00});
        }
    }, [props.visible, props.estoqueLote]); 

    const validar = () => {
        let quantidadeDescartavel = descarteInutilizavel.quantidadeDescartavel;
        let quantidadeInutilizavel = props.estoqueLote?.quantidadeInutilizavel;
        if(quantidadeDescartavel != null && quantidadeInutilizavel != null) {
            if(quantidadeDescartavel > quantidadeInutilizavel || quantidadeDescartavel <= 0) {
                msgAlerta("Alerta", "Quantidade Invalida ");
                return false;
            }
            return true;
        }

        return false;

    }

    const fechar = () => {
        props.setVisible(false);
    }

    const isKgouLt = (unidadeMedida: string) => {
        return unidadeMedida == "KG" || unidadeMedida == "LT";
    }

    const confirmar = () => {
        if(validar()){
            props.onConfirm(descarteInutilizavel); props.setVisible(false)
        }
    }

    return (
        <Dialog header={props.isRecup? "Recuperar" :"Descartar"} visible={props.visible} style={{ width: '35vw', ...props.style }} onHide={() => { fechar() }}
            footer={<>
                <Button label="Cancelar" onClick={() => fechar()} />
                <Button label="Confirmar" onClick={() => { confirmar() }} />
            </>}>
                <div className="row">
                    <label className="col col-sm-12">
                        Produto: {props.estoqueLote?.produto.nome}
                    </label>
                    <label className="col col-sm-12">
                        Lote: {props.estoqueLote?.lote}
                    </label>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Label className="col col-sm-12" obrigatorio>{props.isRecup ? "Quantidade a Recuperar" : "Quantidade a Descartar"}</Label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <InputNumber
                            value={descarteInutilizavel.quantidadeDescartavel}
                            style={{ width: '100%' }}
                            maxLength={12}
                            minFractionDigits={isKgouLt(props.estoqueLote?.produto.unidadeMedida) ? 1 : 0}
                            maxFractionDigits={isKgouLt(props.estoqueLote?.produto.unidadeMedida) ? 8 : 0}
                            locale="pt-BR"
                            useGrouping={false}
                            onChange={(e) => {
                                setDescarteInutilizavel({...descarteInutilizavel, quantidadeDescartavel: e.value})
                            }}
                        />
                    </div>
                </div>
        </Dialog>
    )
}